import React from 'react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import MessageDisplay from 'components/MessageDisplay' // Toastr used to display Error messages only
import ModalAlert from 'components/ModalAlert'
import ContractorForm from './ContractorForm'
import api from '../../utils/api'

const Console = console

class Contractor extends React.Component {
  constructor(props) {
    super(props)
    this.setDirty = this.setDirty.bind(this)
    this.submit = this.submit.bind(this)
    this.closeForm = this.closeForm.bind(this)
    this.modalAlertCancel = this.modalAlertCancel.bind(this)
    this.modalAlertSubmit = this.modalAlertSubmit.bind(this)
    this.state = {
      employerId: 0,
      contractor: null,
      errors: {},
      isDirty: this.props.isDirty,
      modalAlertOpen: false
    }
  }

  componentWillMount() {
    const employerId = this.props.match.params.employerId ? parseInt(this.props.match.params.employerId, 0) : 0
    const contractorId = this.props.match.params.contractorId ? parseInt(this.props.match.params.contractorId, 0) : 0

    if (employerId <= 0) {
      this.props.history.push('/employers')
    } else {
      this.setState({ employerId })
      this.getData(employerId, contractorId)
    }
  }

  getData(employerId, contractorId) {
    const apiCall = () => (contractorId === 0 ? api.getNewContractor(employerId) : api.getContractor(employerId, contractorId))

    apiCall()
      .then(data => this.setState({ contractor: data }))
      .catch(() => {
        this.props.history.push('/employers')
      })
  }

  setDirty() {
    this.setState({ isDirty: true })
  }

  showModalAlert() {
    this.setState({ modalAlertOpen: true })
  }

  modalAlertCancel(e) {
    e.preventDefault()
    this.setState({ modalAlertOpen: false })
  }

  modalAlertSubmit(e) {
    e.preventDefault()
    this.setState({ modalAlertOpen: false })
    this.saveContractor()
  }

  saveContractorWithSimilarCheck() {
    api.updateContractorWithSimilarCheck(this.state.contractor)
      .then((response) => {
        if (response.ok) {
          response.json().then((similar) => {
            if (similar === true) {
              this.showModalAlert()
            } else {
              this.saveContractor()
            }
          })
        } else {
          response.json().then((errors) => {
            if (Object.keys(errors).length === 1 && errors.Error) {
              this.messageDisplay.showError(null, errors.Error)
            } else {
              this.setState({ errors })
            }
            //Console.log(response.statusText)
          })
        }
      })
      .catch(() => {
        this.messageDisplay.showError(null, 'Validation error')
      })
  }

  submit() {
    if (this.state.employerId !== this.state.contractor.employerId) {
      this.messageDisplay.showError(null, 'Contractors cannot be moved to a different employer')
      return
    }

    this.saveContractorWithSimilarCheck()
  }

  saveContractor() {
    const isNew = this.state.contractor.id === 0
    const apiCall = isNew ? api.addContractor : api.updateContractor

    apiCall(this.state.contractor)
      .then((response) => {
        if (response.ok) {
          response.json().then((contractor) => {
            if (!isNew) {
              this.setState({ contractor })
              this.setState({ errors: {} })
              this.setState({ isDirty: false })
            }
            this.closeForm()
          })
        } else {
          response.json().then((errors) => {
            if (Object.keys(errors).length === 1 && errors.Error) {
              this.messageDisplay.showError(null, errors.Error)
            } else {
              this.setState({ errors })
            }
            //Console.log(response.statusText)
          })
        }
      })
  }

  closeForm() {
    this.props.history.push(`/employers/${this.state.employerId}#tab-colleagues`)
  }

  render() {
    return (
      <div>
        <ModalAlert
          modalAlertOpen={this.state.modalAlertOpen}
          modalAlertSubmit={this.modalAlertSubmit}
          modalAlertCancel={this.modalAlertCancel}
          name={`There is already a colleague called ${this.state.contractor ?
            `${this.state.contractor.forename} ${this.state.contractor.surname} with the same job role` : ''}. 
            Are you sure you want to add another?`}
        />
        <MessageDisplay ref={(messageComponent) => { this.messageDisplay = messageComponent }} />
        { this.state.contractor != null &&
        <ContractorForm
          contractor={this.state.contractor}
          errors={this.state.errors}
          submit={this.submit}
          cancel={this.closeForm}
          setDirty={this.setDirty}
        />
        }
      </div>
    )
  }
}

Contractor.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      employerId: PropTypes.string,
      contractorId: PropTypes.string
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default withRouter(Contractor)



// WEBPACK FOOTER //
// ./src/components/Contractor/index.jsx